import React from 'react';
import { Card, Typography, Statistic, Row, Col, Skeleton } from 'antd';
import { UserOutlined, CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const { Text } = Typography;

const COLORS = ['#52c41a', '#1890ff', '#722ed1', '#fa541c', '#faad14', '#13c2c2', '#eb2f96', '#2f54eb'];

const LeadFunnel = ({ data, loading }) => {
  if (loading) {
    return (
      <Card size="small" title={<Text strong>Lead Conversion</Text>}>
        <Skeleton active paragraph={{ rows: 6 }} />
      </Card>
    );
  }

  // Prepare chart data from leads by source
  const chartData = (data?.by_source || []).slice(0, 6).map((item, index) => ({
    name: item.source?.length > 10 ? item.source.substring(0, 10) + '...' : item.source,
    fullName: item.source,
    total: item.total,
    converted: item.converted,
    rate: item.rate,
    fill: COLORS[index % COLORS.length]
  }));

  return (
    <Card size="small" title={<Text strong>Lead Conversion</Text>}>
      {/* Summary Stats */}
      <Row gutter={[16, 8]} style={{ marginBottom: '16px' }}>
        <Col xs={6}>
          <Statistic
            title={<span style={{ fontSize: '11px' }}>Total</span>}
            value={data?.summary?.total_leads || 0}
            prefix={<UserOutlined />}
            valueStyle={{ fontSize: '16px' }}
          />
        </Col>
        <Col xs={6}>
          <Statistic
            title={<span style={{ fontSize: '11px' }}>Converted</span>}
            value={data?.summary?.converted_leads || 0}
            prefix={<CheckCircleOutlined />}
            valueStyle={{ fontSize: '16px', color: '#52c41a' }}
          />
        </Col>
        <Col xs={6}>
          <Statistic
            title={<span style={{ fontSize: '11px' }}>Rate</span>}
            value={data?.summary?.conversion_rate || 0}
            suffix="%"
            valueStyle={{ fontSize: '16px', color: '#1890ff' }}
          />
        </Col>
        <Col xs={6}>
          <Statistic
            title={<span style={{ fontSize: '11px' }}>Avg Days</span>}
            value={data?.summary?.avg_conversion_days || 0}
            prefix={<ClockCircleOutlined />}
            valueStyle={{ fontSize: '16px' }}
          />
        </Col>
      </Row>

      {/* Leads by Source Bar Chart */}
      {chartData.length > 0 ? (
        <ResponsiveContainer width="100%" height={180}>
          <BarChart
            data={chartData}
            margin={{ top: 10, right: 10, left: 0, bottom: 30 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis
              dataKey="name"
              tick={{ fontSize: 9 }}
              angle={-45}
              textAnchor="end"
              height={50}
              interval={0}
            />
            <YAxis
              tick={{ fontSize: 10 }}
              width={35}
            />
            <Tooltip
              formatter={(value, name, props) => {
                if (name === 'total') {
                  return [`${value} leads (${props.payload.converted} converted)`, props.payload.fullName];
                }
                return [value, name];
              }}
              contentStyle={{ fontSize: '12px' }}
            />
            <Bar dataKey="total" radius={[4, 4, 0, 0]}>
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.fill} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div style={{
          height: 180,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Text type="secondary">No lead data available for this period</Text>
        </div>
      )}
    </Card>
  );
};

export default LeadFunnel;
